/**
 * Article Page JavaScript
 * Handles Table of Contents, FAQ Accordion, and Share functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // Smooth Scroll for Table of Contents
  // ============================================
  const tocLinks = document.querySelectorAll('.article-toc__link');
  
  tocLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the ID from the href (remove the # if present)
      let targetId = this.getAttribute('href');
      if (targetId.startsWith('#')) {
        targetId = targetId.substring(1);
      }
      
      // Try to find the element by ID
      let targetElement = document.getElementById(targetId);
      
      // If not found, try to find by data-id attribute
      if (!targetElement) {
        targetElement = document.querySelector(`[data-id="${targetId}"]`);
      }
      
      // If still not found, try to find heading with matching text
      if (!targetElement) {
        const linkText = this.textContent.trim();
        const headings = document.querySelectorAll('.article-page__content h1, .article-page__content h2, .article-page__content h3, .article-page__content h4');
        headings.forEach(heading => {
          if (heading.textContent.trim() === linkText) {
            targetElement = heading;
          }
        });
      }
      
      if (targetElement) {
        const offset = 100; // Offset for fixed header
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        // Add ripple effect
        this.style.position = 'relative';
        const ripple = document.createElement('span');
        ripple.style.cssText = `
          position: absolute;
          border-radius: 50%;
          background: rgba(190, 114, 19, 0.3);
          width: 10px;
          height: 10px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%) scale(0);
          animation: ripple 0.6s ease-out;
          pointer-events: none;
        `;
        this.appendChild(ripple);
        setTimeout(() => ripple.remove(), 600);
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // Update active state with animation
        tocLinks.forEach(l => {
          l.classList.remove('active');
          l.style.transform = 'translateX(0)';
        });
        this.classList.add('active');
        this.style.transform = 'translateX(4px)';
        
        // Highlight the target element briefly
        targetElement.style.transition = 'background-color 0.6s ease';
        targetElement.style.backgroundColor = 'rgba(190, 114, 19, 0.05)';
        setTimeout(() => {
          targetElement.style.backgroundColor = '';
        }, 1500);
      } else {
        console.warn('Target element not found for ID:', targetId);
      }
    });
  });

  // Add ripple animation to CSS dynamically
  if (!document.getElementById('toc-ripple-style')) {
    const style = document.createElement('style');
    style.id = 'toc-ripple-style';
    style.textContent = `
      @keyframes ripple {
        to {
          transform: translate(-50%, -50%) scale(4);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ============================================
  // FAQ Accordion Functionality with Animations
  // ============================================
  const faqQuestions = document.querySelectorAll('.article-faq__question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const answer = this.nextElementSibling;
      const faqItem = this.parentElement;
      
      // Close all other FAQs (optional - remove if you want multiple open)
      faqQuestions.forEach(otherQuestion => {
        if (otherQuestion !== question) {
          const otherAnswer = otherQuestion.nextElementSibling;
          const otherItem = otherQuestion.parentElement;
          otherQuestion.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
          otherItem.classList.remove('is-open');
        }
      });
      
      // Toggle current FAQ
      this.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        // Closing
        answer.hidden = true;
        faqItem.classList.remove('is-open');
      } else {
        // Opening
        answer.hidden = false;
        faqItem.classList.add('is-open');
      }
    });
  });

  // ============================================
  // Share Button Functionality
  // ============================================
  const shareButton = document.querySelector('.article-share__button');
  
  if (shareButton) {
    shareButton.addEventListener('click', function() {
      if (navigator.share) {
        // Use native share API (mobile)
        navigator.share({
          title: document.title,
          url: window.location.href
        }).catch(err => console.log('Error sharing:', err));
      } else {
        // Fallback: copy to clipboard (desktop)
        navigator.clipboard.writeText(window.location.href).then(() => {
          // Show success message
          const originalText = this.querySelector('span').textContent;
          this.querySelector('span').textContent = 'Link copied!';
          
          // Reset after 2 seconds
          setTimeout(() => {
            this.querySelector('span').textContent = originalText;
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy:', err);
          alert('Failed to copy link. Please copy manually: ' + window.location.href);
        });
      }
    });
  }

  // ============================================
  // Highlight Active TOC Item on Scroll
  // ============================================
  if (tocLinks.length > 0) {
    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px -66%',
      threshold: 0
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id') || entry.target.getAttribute('data-id');
          if (id) {
            tocLinks.forEach(link => {
              link.classList.remove('active');
              let linkHref = link.getAttribute('href');
              if (linkHref.startsWith('#')) {
                linkHref = linkHref.substring(1);
              }
              if (linkHref === id) {
                link.classList.add('active');
              }
            });
          }
        }
      });
    }, observerOptions);

    // Observe all elements with IDs that match TOC links
    tocLinks.forEach(link => {
      let targetId = link.getAttribute('href');
      if (targetId.startsWith('#')) {
        targetId = targetId.substring(1);
      }
      
      let targetElement = document.getElementById(targetId);
      
      // If not found by ID, try data-id
      if (!targetElement) {
        targetElement = document.querySelector(`[data-id="${targetId}"]`);
      }
      
      // If still not found, try matching heading text
      if (!targetElement) {
        const linkText = link.textContent.trim();
        const headings = document.querySelectorAll('.article-page__content h1, .article-page__content h2, .article-page__content h3, .article-page__content h4');
        headings.forEach(heading => {
          if (heading.textContent.trim() === linkText) {
            targetElement = heading;
          }
        });
      }
      
      if (targetElement) {
        observer.observe(targetElement);
      }
    });
  }

  // ============================================
  // Smooth Scroll Polyfill for Older Browsers
  // ============================================
  // Check if smooth scroll is supported
  if (!('scrollBehavior' in document.documentElement.style)) {
    // Add polyfill for older browsers
    const smoothScrollPolyfill = function(target, duration) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 80;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    };
  }

  // ============================================
  // Make Tables Responsive with Wrapper
  // ============================================
  const tables = document.querySelectorAll('.article-page__content table');
  
  tables.forEach(table => {
    // Check if table is not already wrapped
    if (!table.parentElement.classList.contains('table-wrapper')) {
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      
      // Wrap the table
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      
      // Add scroll indicator for mobile
      const scrollIndicator = document.createElement('div');
      scrollIndicator.className = 'table-scroll-indicator';
      scrollIndicator.innerHTML = '<span>← Scroll to see more →</span>';
      wrapper.appendChild(scrollIndicator);
      
      // Hide indicator when scrolled to end
      wrapper.addEventListener('scroll', function() {
        const isScrolledToEnd = this.scrollWidth - this.scrollLeft <= this.clientWidth + 10;
        if (isScrolledToEnd) {
          scrollIndicator.style.opacity = '0';
        } else {
          scrollIndicator.style.opacity = '1';
        }
      });
      
      // Check if table needs scrolling
      if (table.scrollWidth <= wrapper.clientWidth) {
        scrollIndicator.style.display = 'none';
      }
    }
  });

  // Re-check table widths on window resize
  window.addEventListener('resize', function() {
    const wrappers = document.querySelectorAll('.table-wrapper');
    wrappers.forEach(wrapper => {
      const table = wrapper.querySelector('table');
      const indicator = wrapper.querySelector('.table-scroll-indicator');
      if (table && indicator) {
        if (table.scrollWidth <= wrapper.clientWidth) {
          indicator.style.display = 'none';
        } else {
          indicator.style.display = 'block';
        }
      }
    });
  });

});
